import React, { createContext, useContext } from 'react';
import { TaskFieldContainer, TaskFieldContainerProps } from '../../inputs/containers/TaskFieldContainer';

type TaskFieldContainerComponent = React.FC<TaskFieldContainerProps>;

const TaskFieldContainerContext = createContext<TaskFieldContainerComponent>(TaskFieldContainer);

export const useTaskFieldContainer = () => useContext(TaskFieldContainerContext);

export const TaskFieldContainerProvider: React.FC<{ container: TaskFieldContainerComponent }> = ({
  container,
  children,
}) => {
  return <TaskFieldContainerContext.Provider value={container}>{children}</TaskFieldContainerContext.Provider>;
};
